export class PermissionConstants {
    static readonly Full = 'Full';
    static readonly View = 'View';
    static readonly Create = 'Create';
    static readonly Edit = 'Edit';
    static readonly Matching = 'Matching';
    static readonly Import = 'Import';
    static readonly Export = 'Export';
    static readonly Delete = 'Delete';
    static readonly DeleteCompleted = 'DeleteCompleted';
    static readonly DeletePending = 'DeletePending';
    static readonly DeleteWindowed = 'DeleteWindowed'
}